import {observer} from "mobx-react";
import styled from "styled-components";
import {useStore} from "@/store";
import {useEffect} from "react";
import {MENU_PATHS_MAP} from "@/components/constants/routes";
import {usePathname, useRouter, useSearchParams} from "next/navigation";

const MenuNavigationWrapMo = observer(() => {
    const {navigationStore} = useStore();
    const pathname = usePathname();
    const router = useRouter();
    const params = useSearchParams();
    const menuId = params.get("menu-id");
    useEffect(() => {
        const handleMouseOut = (e) => {
            if (e.relatedTarget === null) {
                navigationStore.setOpenIndex(null);
            }
        };
        window.addEventListener("mouseout", handleMouseOut);
        return () => {
            window.removeEventListener("mouseout", handleMouseOut);
        };
    }, []);
    useEffect(() => {
        navigationStore.setClearNavigation("wrap");
    }, [pathname]);

    return(
        <MenuNavigationInnerMo className={"menu"}>
            {
                menuId &&
                navigationStore.setMakeNaviMenu() && navigationStore.setMakeNaviMenu().length > 0 &&
                navigationStore.setMakeNaviMenu().filter(item => item.depth === 1).map((node, idx) => {
                    navigationStore.setMenuOpen(node, idx);
                    const children = navigationStore.setMakeNaviMenu().filter(child => child.depth === 2 && child.trail[0].menuId === node.menuId);
                    const isOpen = navigationStore.mobileOpenIdx.includes(idx);
                    const basePath = MENU_PATHS_MAP.find(map => map.name === node.title)?.path;
                    return (
                        <li
                            key={node.menuId}
                            className={`list ${node.active ? "active" : ""} ${isOpen ? "on" : ""} dem`}
                        >
                            <div
                                className="hover-wrapper"
                            >
                                <div
                                    className="depth_1"
                                    onClick={() => {
                                        if(node.type === "FOLDER" && node.children && node.children.length > 0){
                                            navigationStore.setToggleMobile(idx, false);
                                        } else {
                                            if(node.type === "PAGE"){
                                                if(node.component){
                                                    const pagePath  = navigationStore.setFilterPageUrl(node, basePath, menuId);
                                                    router.push(pagePath);
                                                } else {
                                                    alert("준비 중입니다.");
                                                }
                                            }  else {
                                                alert("준비 중입니다.");
                                            }
                                        }
                                    }}
                                >
                                    {node.title}
                                </div>
                                {
                                    children.length > 0 &&
                                    <ul className="depth_2">
                                        {children.map(child => (
                                            <li
                                                key={child.menuId}
                                                className={`child ${child.active ? "active" : ""}`}
                                                onClick={() => {
                                                    let pagePath = "";
                                                    if(child.children && child.children.length > 0){
                                                        const target = navigationStore.findFirstNonFolder(child.children);
                                                        if (!target) {
                                                            alert("준비 중입니다.");
                                                            return;
                                                        }
                                                        pagePath  = navigationStore.setFilterPageUrl(target, basePath, menuId);
                                                    } else {
                                                        pagePath  = navigationStore.setFilterPageUrl(child, basePath, menuId);
                                                    }
                                                    router.push(pagePath);
                                                    navigationStore.setSideNavigationOpen(!navigationStore.sideNavigationOpen);
                                                }}
                                            >
                                                {child.title}
                                            </li>
                                        ))}
                                    </ul>
                                }
                            </div>

                        </li>
                    );
                })
            }
        </MenuNavigationInnerMo>
    )
});
const MenuNavigationInnerMo = styled.div`
    padding: 40px 0 108px;
    display: block;
    height: auto;
    &.menu{
        .list{
            text-align: center;
            display: block;
            height: auto;
            & + .list{
                margin-top: 24px;
            }
            .hover-wrapper{
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
            }
            .depth_1{
                font-weight: 500;
                font-size: 20px;
                line-height: 24px;
                color: #333333;
                position: relative;
                cursor: pointer;
            }
            .depth_2{
                padding: 0;
                height: 0;
                overflow: hidden;
                transform: scaleY(0);
                transform-origin: left top;
                transition: transform 0.12s, height 0.1s;
                position: relative;
                display: block;
                text-align: center;
                inset: auto;
                box-shadow: none;
                .child{
                    &.active{
                        font-weight: 600;
                        color: #333;
                    }
                    cursor: pointer;
                    font-weight: 500;
                    font-size: 14px;
                    line-height: 18px;
                    color: #666;
                    width: auto;
                    height: 40px;
                }
            }

            &.active{
                .depth_1{
                    color: #4939B1;
                    font-weight: 600;
                    &::after{
                        content: "";
                        position: absolute;
                        width: 100%;
                        bottom: -6px;
                        left: 0;
                        height: 2px;
                        background-color: #4939B1;
                        z-index: 50;
                    }
                }
            }
            &.on{
                .depth_2{
                    padding: 24px 0 24px;
                    transform: scaleY(1);
                    height: auto;
                    overflow: visible;
                }
            }
        }
    }
`
export default MenuNavigationWrapMo;